/**
 * HEADER STICKY + RECHERCHE MOBILE & DESKTOP CUSTOM
 * Version Charmant Studio
 */

document.addEventListener(
  'DOMContentLoaded',
  function () {
    let lastScrollTop = 0;
    let lastScrollDirection = 0;
    let hideHeaderTimeout;
    let closeSearchFn = null; // pour la recherche mobile

    const headerWrapper = document.querySelector('.header-wrapper');
    const stickyHeader = document.querySelector('sticky-header');

    if (!headerWrapper) return;

    const thresholdUp = 50;
    const thresholdDown = 1;

    /* ----------------- TRANSITIONS HEADER ----------------- */

    headerWrapper.addEventListener('transitionend', (e) => {
      if (e.target === headerWrapper) {
        if (
          e.propertyName === 'opacity' &&
          parseFloat(getComputedStyle(e.target).opacity) === 0
        ) {
          headerWrapper.style.pointerEvents = 'none';
        }
      }
    });

    headerWrapper.addEventListener('transitionstart', (e) => {
      if (e.target === headerWrapper) {
        if (
          e.propertyName === 'opacity' &&
          parseFloat(getComputedStyle(e.target).opacity) > 0
        ) {
          headerWrapper.style.pointerEvents = 'all';
        }
      }
    });

    window.addEventListener(
      'scroll',
      function () {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let scrollDirection = scrollTop > lastScrollTop ? 1 : -1;
        let threshold = scrollDirection === 1 ? thresholdDown : thresholdUp;

        if (scrollTop < 50) {
          headerWrapper.setAttribute('data-scroll-direction', 'none');
          headerWrapper.style.pointerEvents = 'all';
          if (hideHeaderTimeout) clearTimeout(hideHeaderTimeout);
        } else if (Math.abs(scrollTop - lastScrollTop) >= threshold) {
          if (scrollDirection === 1) {
            headerWrapper.setAttribute('data-scroll-direction', 'down');
            if (hideHeaderTimeout) clearTimeout(hideHeaderTimeout);
            closeOpenMenus();
          } else {
            headerWrapper.style.pointerEvents = 'all';
            setTimeout(() => {
              headerWrapper.setAttribute('data-scroll-direction', 'up');
            }, 10);
          }
          lastScrollTop = scrollTop;
          lastScrollDirection = scrollDirection;
        }
      },
      { passive: true }
    );

    /* ----------------- FERMETURE MENUS AU SCROLL ----------------- */

    function closeOpenMenus() {
      const openDetails = headerWrapper.querySelectorAll('details[open]');
      openDetails.forEach((detail) => {
        if (!detail.classList.contains('menu-drawer-container')) {
          detail.removeAttribute('open');
        }
      });

      const searchModalDetails = headerWrapper.querySelector(
        '.header__search details'
      );
      if (searchModalDetails && searchModalDetails.hasAttribute('open')) {
        searchModalDetails.removeAttribute('open');
      }

      if (typeof closeSearchFn === 'function') {
        closeSearchFn();
      }
    }

    headerWrapper.setAttribute('data-scroll-direction', 'none');
    headerWrapper.style.pointerEvents = 'all';

    /* On neutralise le comportement natif de sticky-header Dawn */
    if (stickyHeader) {
      const originalHide = stickyHeader.hide;
      const originalReveal = stickyHeader.reveal;
      const originalReset = stickyHeader.reset;
      if (originalHide) stickyHeader.hide = function () {};
      if (originalReveal) stickyHeader.reveal = function () {};
      if (originalReset) stickyHeader.reset = function () {};
    }

    /* =====================================================
       RECHERCHE DESKTOP NATIVE (INTÉGRÉE)
       ===================================================== */

    initDesktopSearch();

    function initDesktopSearch() {
      const desktopSearchDetails = headerWrapper.querySelector(
        '.header__search details'
      );
      if (!desktopSearchDetails) return;

      desktopSearchDetails.addEventListener('toggle', function () {
        const isOpen = desktopSearchDetails.hasAttribute('open');

        if (isOpen) {
          headerWrapper.classList.add('search-desktop-open');
        } else {
          headerWrapper.classList.remove('search-desktop-open');
        }
      });
    }

    /* =====================================================
       RECHERCHE MOBILE CUSTOM (TYPE TWOJEYS)
       ===================================================== */

    // initMobileSearch(); // Désactivé - recherche masquée

    function initMobileSearch() {
      const mq = window.matchMedia('(max-width: 989px)');
      if (!mq.matches) return;

      const headerIcons =
        headerWrapper.querySelector('.header__icons') ||
        document.querySelector('.header__icons');

      if (!headerIcons) return;

      // Évite d'initialiser plusieurs fois au cas de JS rechargé
      if (headerIcons.dataset.shSearchInit === '1') return;
      headerIcons.dataset.shSearchInit = '1';

      const nativeSearch = headerIcons.querySelector('.header__search');
      if (nativeSearch) {
        nativeSearch.style.display = 'none';
      }

      const searchContainer = document.createElement('div');
      searchContainer.className = 'sh-search';

      searchContainer.innerHTML = `
        <button type="button" class="header__icon sh-search__icon" aria-label="Ouvrir la recherche">
          <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
            <path d="M3.39746 12.2891C3.39746 7.46582 7.31836 3.54492 12.1416 3.54492C16.9648 3.54492 20.8857 7.46582 20.8857 12.2891C20.8857 14.1689 20.2734 15.9092 19.2529 17.3164L24.1621 22.2363C24.4521 22.5371 24.6025 22.9346 24.6025 23.3643C24.6025 24.2559 23.9473 24.9434 23.0342 24.9434C22.6152 24.9434 22.1963 24.8037 21.8955 24.4922L16.9541 19.5508C15.5791 20.4854 13.9355 21.0332 12.1416 21.0332C7.31836 21.0332 3.39746 17.1123 3.39746 12.2891ZM5.6748 12.2891C5.6748 15.8555 8.56445 18.7559 12.1416 18.7559C15.708 18.7559 18.6084 15.8555 18.6084 12.2891C18.6084 8.72266 15.708 5.82227 12.1416 5.82227C8.56445 5.82227 5.6748 8.72266 5.6748 12.2891Z" fill="currentColor"></path>
          </svg>
        </button>
        <div class="sh-search__wrapper">
          <form class="sh-search__form" action="/search" method="get" role="search">
            <input class="sh-search__input" type="search" name="q" autocomplete="off" placeholder="Recherche">
            <input type="hidden" name="options[prefix]" value="last">
          </form>
          <button type="button" class="sh-search__close" aria-label="Fermer la recherche">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      `;

      headerIcons.prepend(searchContainer);

      const openBtn = searchContainer.querySelector('.sh-search__icon');
      const closeBtn = searchContainer.querySelector('.sh-search__close');
      const input = searchContainer.querySelector('.sh-search__input');

      function openSearch() {
        headerWrapper.classList.add('search-opened');
        document.body.classList.add('searching');
        if (input) {
          setTimeout(() => {
            input.focus();
          }, 10);
        }
      }

      closeSearchFn = function () {
        headerWrapper.classList.remove('search-opened');
        document.body.classList.remove('searching');
        if (input) {
          input.value = '';
          input.blur();
        }
      };

      if (openBtn) {
        openBtn.addEventListener('click', openSearch);
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', closeSearchFn);
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          if (typeof closeSearchFn === 'function') {
            closeSearchFn();
          }
        }
      });
    }
  },
  { once: true }
);
